import type { Theme } from '@mui/material/styles';
import {bloxColors} from 'themes/constants'
import type { HasStatus, StatusColorKey } from
  'components/Search/components/fields/generic/StatusIndicators/types/status';

const getStatusColor = (
  record: HasStatus | null | undefined,
  theme: Theme,
  key?: StatusColorKey,
): string => {
  const statusValue = String(key ?? record?.status ?? '');

  switch (statusValue) {
    // Processing
    case 'processing':
      return bloxColors.indigo;

    // Green
    case 'published':
    case 'imported':
      return theme.palette.success.main;
    
    // Red
    case 'deleted': // Row opacity makes it look orange
    case 'blocked_by_workflow':
    case 'no_publish':
      return theme.palette.error.main;

    // Blue
    case 'draft':
      return theme.palette.primary.main;

    // Orange
    case 'unpublished_changes':
      return bloxColors.orange;
    
    // Yellow
    case 'scheduled':
      return bloxColors.yellow;

    // Gray
    case 'unpublished':
    case 'locked':
    case 'placed_on_page':
      return theme.palette.text.secondary;
    
    default:
      return theme.palette.text.secondary;
  }
};

export default getStatusColor;